var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decline",on:{"click":_vm.disconnect}},[_c('svg',{staticClass:"decline-key",attrs:{"width":"44","height":"44"}},[_c('use',{attrs:{"href":'/icons.svg#decline',"width":"44","height":"44"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }